import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class ButtonComponent {
  @Input() text: string
  @Input() extraClasses: string
  @Input() disabled = false
  @Input() icon: string
  @Input() tooltipText: string
  @Output() onClick = new EventEmitter<boolean>()

  constructor() {}

  onHandleClick() {
    this.onClick.emit(true)
  }
}
